import $ from 'jquery';
import { gsap, TimelineMax, Power2, Power4, CSSRulePlugin, ScrollTrigger } from 'gsap/all';
require("../__vendor/SplitText.min.js");
require("../__vendor/jquery.bxslider.js");

const slider = () => {
    let slider = $(".slider"),
        sliderMobile = $(".slider--mobile");

    if($(window).width() > 767) {
        slider = $(".slider").bxSlider({
            mode: 'fade',
            speed: 800,
            pager: false,
            controls: false,
            keyboardEnabled: true
        });
    }

    if($(window).width() < 768) {
        sliderMobile = $(".slider--mobile").bxSlider({
            mode: 'fade',
            speed: 800,
            pager: false,
            controls: false,
            auto: true,
            pause: 8000,
            keyboardEnabled: false
        });
    }
};

export default slider;